import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import PropTypes from 'prop-types';

const PostalImg = props => {

    const { idPostal, title, urlAssets } = props;

    return (
        <article className="col-12 col-md-6 p-0 p-md-1 text-center">
            <LazyLoadImage
                alt={title}
                className="img-fluid"
                effect="blur"
                src={`${urlAssets}/img/postal/${idPostal}.png`}
            /> 
        </article>
    )
}

export default PostalImg;

PostalImg.propTypes = {
    idPostal: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired
}
